var map = {
	"./Annotations/action": 162,
	"./Annotations/action.js": 162,
	"./Annotations/api": 163,
	"./Annotations/api.js": 163,
	"./AssignmentTemplates": 161,
	"./AssignmentTemplates/": 161,
	"./AssignmentTemplates/edit": 393,
	"./AssignmentTemplates/edit.js": 393,
	"./AssignmentTemplates/index": 161,
	"./AssignmentTemplates/index.js": 161,
	"./AssignmentTemplates/new": 386,
	"./AssignmentTemplates/new.js": 386,
	"./AssignmentTemplates/show": 394,
	"./AssignmentTemplates/show.js": 394,
	"./UserAssignment": 160,
	"./UserAssignment/": 160,
	"./UserAssignment/AttachmentSection": 165,
	"./UserAssignment/AttachmentSection.js": 165,
	"./UserAssignment/Form": 169,
	"./UserAssignment/Form.js": 169,
	"./UserAssignment/StudentConfidence": 168,
	"./UserAssignment/StudentConfidence.js": 168,
	"./UserAssignment/actions": 70,
	"./UserAssignment/actions.js": 70,
	"./UserAssignment/api": 81,
	"./UserAssignment/api.js": 81,
	"./UserAssignment/index": 160,
	"./UserAssignment/index.js": 160,
	"./modal/AttachmentPreviewer": 166,
	"./modal/AttachmentPreviewer.js": 166,
	"./modal/DeleteModal": 167,
	"./modal/DeleteModal.js": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;